<template>
  <div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%"
        border
        @cell-click="toggleSelection"
        v-loading="listLoading"
    >
      <el-table-column property="showDate" label="日期" />
      <el-table-column property="" label="数量" class-name="cursor">
        <template #default="scope">
          <span style="color: #409eff">{{ scope.row.num }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api'
import { getUserVisitDateNumList } from '@/api/url'
import Dialog from '@/assets/js/dialog'
import UserVisitDateUser from "../components/UserVisitDateUser";
export default {
  name: "GreetingDateNum",
  props: {
    value: Object
  },
  data() {
    return {
      userId: this.value.userId,

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage() {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['id'] = this.userId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getUserVisitDateNumList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {

      if(column.label == '数量') {
        Dialog.open({
          title: '日期对应来访列表',
          component: UserVisitDateUser,
          data: {
            userId: this.userId,
            showDate: row.showDate,
            width: '800px'
          },
          close: () => {

          }
        })
      }

    },

  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
